function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 62.5,
  r: 62.5,
  fill: "#DCC6B7"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1155_31303)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M84.8192 42.3073H77.9858C77.9858 34.7565 71.87 28.6406 64.3192 28.6406C56.7683 28.6406 50.6525 34.7565 50.6525 42.3073H43.8192C40.0608 42.3073 36.9858 45.3823 36.9858 49.1406V90.1406C36.9858 93.899 40.0608 96.974 43.8192 96.974H84.8192C88.5775 96.974 91.6525 93.899 91.6525 90.1406V49.1406C91.6525 45.3823 88.5775 42.3073 84.8192 42.3073ZM64.3192 35.474C68.0775 35.474 71.1525 38.549 71.1525 42.3073H57.4858C57.4858 38.549 60.5608 35.474 64.3192 35.474ZM84.8192 90.1406H43.8192V49.1406H50.6525V55.974C50.6525 57.8531 52.19 59.3906 54.0692 59.3906C55.9483 59.3906 57.4858 57.8531 57.4858 55.974V49.1406H71.1525V55.974C71.1525 57.8531 72.69 59.3906 74.5692 59.3906C76.4483 59.3906 77.9858 57.8531 77.9858 55.974V49.1406H84.8192V90.1406Z",
  fill: "#373435"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1155_31303"
}, /*#__PURE__*/React.createElement("rect", {
  width: 82,
  height: 82,
  fill: "white",
  transform: "translate(23.3193 21.8047)"
})));

function SvgSavedBagsNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 126 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedBagsNews);
export default __webpack_public_path__ + "static/media/saved_bags_news.ebda9f20.svg";
export { ForwardRef as ReactComponent };